import { lazy } from 'react';

const list = lazy(() => import('pages/warehousePresets/List'));
const edit = lazy(() => import('pages/warehousePresets/Edit'));
const create = lazy(() => import('pages/warehousePresets/Create'));

export { list, edit, create };
